import { API } from '../../../common/api'
import { ignoreNotFound } from '../errorDisposition'
import { azureEngineV2ServiceUrl } from '../../../common/utils/constants'

export interface MicrosoftPipelineReferralQueryParams {
  deal_name?: string
  customer_name?: string
  page_number: number
  page_size: number
  sort_by: 'updated_at' | 'estimated_close_date'
  sort_order: 'asc' | 'desc'
}

export interface MicrosoftSyncHistoryQueryParams {
  page_number: number
  page_size: number
}

export const fetchMicrosoftReferrals = (
  accountId: string,
  params: MicrosoftPipelineReferralQueryParams
) =>
  API.get(
    `${azureEngineV2ServiceUrl}/v2/accounts/${encodeURIComponent(accountId)}/referrals`,
    {
      params,
      classifyError: ignoreNotFound,
    }
  )

export const fetchMicrosoftPipelineMetrics = (accountId: string) =>
  API.get(
    `${azureEngineV2ServiceUrl}/v2/accounts/${encodeURIComponent(accountId)}/referrals/dashboard-metrics`,
    { classifyError: ignoreNotFound }
  )

export const fetchMicrosoftReferralSyncs = (
  accountId: string,
  referralId: string,
  params: MicrosoftSyncHistoryQueryParams
) =>
  API.get(
    `${azureEngineV2ServiceUrl}/v2/accounts/${encodeURIComponent(accountId)}/referrals/${encodeURIComponent(referralId)}/syncs`,
    {
      params,
      classifyError: ignoreNotFound,
    }
  )
